var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgCusPage1 = function SvgCusPage1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 60,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cus_page_1_svg__clip0_8586_7941)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M99.295 29.71l-5.179 2.805-5.183 2.806.812 5.835.813 5.836-5.85-1.3-5.849-1.295-1.905 5.657-1.905 5.656-5.11-3.131-5.11-3.136-3.31 4.99-3.316 4.987-4.274-4.196-4.28-4.197-4.278 4.197-4.28 4.196-3.31-4.986-3.314-4.99-5.106 3.135-5.11 3.131-1.91-5.656-1.905-5.661-5.85 1.3-5.849 1.299.813-5.84.813-5.836-5.184-2.805L0 29.71l5.184-2.805 5.179-2.806-.813-5.835-.813-5.835 5.85 1.294 5.849 1.3 1.905-5.657 1.91-5.656 5.105 3.131 5.11 3.136 3.315-4.99L41.091 0l4.28 4.196 4.279 4.197 4.279-4.197L58.203 0l3.315 4.986 3.31 4.99 5.11-3.135 5.106-3.136 1.91 5.661 1.91 5.661 5.85-1.3 5.849-1.299-.813 5.84-.813 5.836 5.18 2.8 5.178 2.806z",
    fill: "#B66CFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "cus_page_1_svg__clip0_8586_7941"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h99.295v59.42H0z"
  })))));
};
export default SvgCusPage1;